export default {
    path: 'file',
    component: () => import('../File.vue'),
    children: [
        {
            path: '',
            name: 'Danh Sách Tệp',
            component: () => import('../table/Table.vue')
        },
    ]
};